import React from 'react';

const useDelayDebounceEffect = (callbackFn: Function, dependencies: Array<any>, delay: number) => {
    React.useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            callbackFn();
        }, delay);

        return () => clearTimeout(delayDebounceFn);
    }, [...dependencies]);
}

export default useDelayDebounceEffect;